/**
 * Generate CSS class name for status badges
 * @param {string} status - Status value
 * @param {string} prefix - CSS class prefix
 * @returns {string} CSS class name
 */
export const getStatusClassName = (status, prefix = "status") => {
  return `${prefix} ${prefix}--${status.toLowerCase()}`;
};

/**
 * Filter array of objects based on search value across multiple fields
 * @param {Array} data - Array of objects to filter
 * @param {string} searchValue - Search value
 * @param {Array} searchFields - Array of field names to search in
 * @returns {Array} Filtered array
 */
export const filterDataBySearch = (data, searchValue, searchFields) => {
  if (!searchValue || searchValue.trim() === "") {
    return data;
  }

  const lowerSearchValue = searchValue.toLowerCase().trim();

  return data.filter((item) => {
    return searchFields.some(
      (field) =>
        item[field] &&
        item[field].toString().toLowerCase().includes(lowerSearchValue)
    );
  });
};

/**
 * Generate search options for SearchBar component
 * @param {string} placeholder - Placeholder text for global search
 * @returns {Array} Search options array
 */
export const generateGlobalSearchOptions = (
  placeholder = "Search across all data"
) => {
  return [
    {
      value: "global",
      label: "Search All Fields",
      placeholder,
    },
  ];
};
